var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card", value: "contractForm" },
          on: { "tab-click": _vm.handleTabClick },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.tabTitle, name: "contractForm" } },
            [
              _c("contractForm", {
                attrs: { rows: _vm.detailData, type: _vm.detailType },
                on: { closeDetail: _vm.closeDetail },
              }),
            ],
            1
          ),
          _vm.isShowLog
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("basicData.OperationalLogs"),
                    name: "operationLog",
                  },
                },
                [_c("operationLog", { attrs: { rows: _vm.detailData } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }